import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { MemberSelect as LocalMemberSelect } from '../../components/MemberSelect'

export const MemberSelect = connect(
  LocalMemberSelect,
  mapReadPretty(LocalMemberSelect, {
    disabled: true
  })
)
